export default (() => {
  document.querySelectorAll('video.js-autoplay').forEach(function (video) {
    video.playsInline = true
    video.autoplay = false
    video.muted = true
    video.loop = true
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play()
          } else {
            video.pause()
          }
        })
      },
      { threshold: 0.5 }
    )
    observer.observe(video)
  })
})()
